import * as React from "react";
import { Form, Select, DatePicker, Input } from "antd";
import {
  ReportingPeriodPermissionForm,
  ReportingPeriodPermissionAction,
  DateFormats
} from "../../../../../common/Constants";
import moment from "moment";
import SelectInput from "../../../../components/app/SelectInput";

const PeriodPermissionForm = ({
  getFieldDecorator,
  translate,
  codebooks,
  rowData,
  disabled
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
  codebooks?: any;
  disabled?: boolean;
}) => {
  return (
    <Form>
      <Form.Item>
        {getFieldDecorator(ReportingPeriodPermissionForm.Fields.ID, {
          initialValue: rowData && rowData.id
        })(<Input style={{ display: "none" }} />)}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator(
          ReportingPeriodPermissionForm.Fields.APPLICANT_REPORTING_PERIOD_ID,
          {
            initialValue: rowData && rowData.applicantReportingPeriodId
          }
        )(<Input style={{ display: "none" }} />)}
      </Form.Item>
      <Form.Item label={translate("reporting_period_permission_form.action")}>
        {getFieldDecorator(ReportingPeriodPermissionForm.Fields.ACTION, {
          initialValue: rowData && rowData.action,
          rules: [
            {
              required: true,
              message: translate(
                "reporting_period_permission_form.required_messages",
                {
                  field: translate("reporting_period_permission_form.action")
                }
              )
            }
          ]
        })(
          <Select
            placeholder={translate(
              "reporting_period_permission_form.select_action"
            )}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            disabled={disabled}
          >
            <Select.Option key={ReportingPeriodPermissionAction.EDIT}>
              {ReportingPeriodPermissionAction.EDIT}
            </Select.Option>
            <Select.Option key={ReportingPeriodPermissionAction.READ}>
              {ReportingPeriodPermissionAction.READ}
            </Select.Option>
          </Select>
        )}
      </Form.Item>

      <div className="ant-form-row-two-items">
        <Form.Item
          label={translate("reporting_period_permission_form.from_date")}
          className="ant-form-item-width"
        >
          {getFieldDecorator(ReportingPeriodPermissionForm.Fields.FROM_DATE, {
            initialValue:
              rowData && rowData.fromDate
                ? moment(rowData.fromDate, DateFormats.DATE)
                : undefined,
            rules: [
              {
                required: true,
                message: translate(
                  "reporting_period_permission_form.required_messages",
                  {
                    field: translate(
                      "reporting_period_permission_form.from_date"
                    )
                  }
                )
              }
            ]
          })(
            <DatePicker
              placeholder={translate(
                "reporting_period_permission_form.select_date"
              )}
              locale={{ dateFormat: DateFormats.DATE }}
              disabled={disabled}
              showToday={false}
            />
          )}
        </Form.Item>

        <Form.Item
          label={translate("reporting_period_permission_form.to_date")}
          className="ant-form-item-width"
        >
          {getFieldDecorator(ReportingPeriodPermissionForm.Fields.TO_DATE, {
            initialValue:
              rowData && rowData.toDate
                ? moment(rowData.toDate, DateFormats.DATE)
                : undefined
          })(
            <DatePicker
              placeholder={translate("reporting_periods.select_date")}
              locale={{ dateFormat: DateFormats.DATE }}
              showToday={false}
            />
          )}
        </Form.Item>
      </div>

      <Form.Item
        label={translate("reporting_period_permission_form.user_code")}
      >
        {getFieldDecorator(ReportingPeriodPermissionForm.Fields.USER_CODE, {
          initialValue: rowData && rowData.userCode,
          rules: [
            {
              required: true,
              message: translate(
                "reporting_period_permission_form.required_messages",
                {
                  field: translate("reporting_period_permission_form.user_code")
                }
              )
            }
          ]
        })(
          <SelectInput
            placeholder={translate(
              "reporting_period_permission_form.select_user_code"
            )}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            disabled={disabled}
            selectOptionKey={"userCode"}
            selectOptionValue={"user"}
            selectOptions={codebooks}
          />
        )}
      </Form.Item>
    </Form>
  );
};

export default PeriodPermissionForm;
